// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","blue":"Header_blue__rCgzG","shadow":"Header_shadow__AwyYI","white":"Header_white__e08Ve","settings":"Header_settings__90oOf"};